import { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { FiCheck, FiFolder, FiPhone, FiSearch } from "react-icons/fi";

import classes from "./stepper.module.scss";

const Stepper = (props) => {
  const history = useHistory();

  const path = history.location.pathname.toLowerCase();

  const steps = [
    {
      id: 1,
      icon: <FiSearch />,
      title: "1. Buscar Acta",
      description: "Ingresá los datos de tu acta",
      active: path === "/acta",
      completed: path === "/files" || path === "/contact",
    },
    {
      id: 2,
      icon: <FiFolder />,
      title: "2. Cargar Documentación",
      description: "Subí los archivos que quieras enviar",
      active: path === "/files",
      completed: path === "/contact",
    },
    {
      id: 3,
      icon: <FiPhone />,
      title: "3. Datos de Contacto",
      description: "Completá tu teléfono o e-mail para que te contactemos",
      active: path === "/contact",
      completed: false,
    },
  ];

  return (
    <div className={classes.stepper}>
      {steps.map((step, index) => (
        <Fragment key={step.id}>
          <div
            className={`${classes.step} 
            ${step.active ? classes.active : null} 
            ${step.completed ? classes.completed : null}`}
          >
            <div className={classes.icon}>
              {step.completed ? <FiCheck /> : step.icon}
            </div>
            <div>
              <div className={classes.title}>{step.title}</div>
              <div className={classes.description}>{step.description}</div>
            </div>
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default Stepper;
